import React, { memo, useContext } from 'react';

import BaseCarousel from 'b2b-ui-components-lib/lib/components/baseCarousel';

import { AppContext } from 'App';

import { carouselRepositoryDefaultConfigs } from 'home/view/check-feasibility/unauth-view/constant';

import resourceImage from 'assests/svg/resource.svg';

import './OurRepository.scss';

const OurRepository = () => {
  const { pageData } = useContext(AppContext);
  const { title, list, tagType } = pageData?.repository;

  BaseCarousel.defaultProps = {
    ...carouselRepositoryDefaultConfigs,
    carouselContainerClass: ''
  };

  return (
    <div id="repositorySection" className="repositorySection">
      <div className="container">
        <h2 className="repository_head">{title}</h2>

        <BaseCarousel>
          {list?.map((item, index) => (
            <div className="box" key={index} role="button" onClick={() => window.open(item?.link, '_blank')}>
              <div className="content_card">
                <h2 className="sub_text">
                  {item?.title}
                  <i className="arrowright"></i>
                  {item?.subTitle && <span className="text_content">{item?.subTitle}</span>}
                </h2>
                <div className="tag_label">{item?.tagType}</div>
              </div>
              <div className="image_box">
                <img src={item?.image || resourceImage} alt="" />
              </div>
            </div>
          ))}
        </BaseCarousel>
        <div className="view_area">
          <a href="https://www.airtel.in/business/b2b/resources/" target="_blank">
            View All <i className="arrowright"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default memo(OurRepository);
